import { render, staticRenderFns } from "./MandateDataITPSP.vue?vue&type=template&id=8abad7a8&"
import script from "./MandateDataITPSP.vue?vue&type=script&lang=js&"
export * from "./MandateDataITPSP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports